<template>
	<div
		:class="getStepClass(step)"
		class="step-item" 
			
			:data-clickable="step.clickable_el ? 'true' : 'false'" 
			:data-clickable-url="step.clickable_el ? step.clickable_el.url : null"
			:data-actionable="step.status_actions_rendered || step.clickable_el ? 'yes' : 'no'"
			><a href="" class="elevation-1">{{ step.index + 1 }}</a>
			<!-- {# {{ (component.post.steps_mode != 'super_strict' and step.active) or ( component.post.steps_mode == 'strict' and step_index > component.current_step_index ) or step_index == component.current_step_index ? 'active' }}  #}
			{{ step.active ? 'active' }}
			{{ step_index == component.current_step_index ? 'current' }}" -->
		<article class="step step-card card elevation-1 module-store--grid__item h6">
			<div class="step-inner" >
				<h6 class="top-title">{{ step.top_title }}</h6>
				<h3>{{ step.title }}</h3>
				<div class="three-lines-wrap description color-gray">{{ step.description }}</div>
		</div>
		
		<slot name="progressBar"></slot>
		<!-- {% include 'components/steppers/_step-buttons.twig' %} -->
		<!--<pre>{{ component.links_target }}</pre> -->
		<slot name="stepButtons"></slot>

		</article>
	</div><!-- /step-item -->
</template>

<script>
export default {
	name: 'StepperStepComponent',
	props: {
		step: {
			type: Object,
			required: true,
			default: {}
		},
		stepIndex: {
			type: Number,
			default: 0,
		},
		stepsMode: {
			type: String,
			required: true,
			default: 'relaxed'
		},
		currentStepIndex: {
			type: Number,
			default: 0,
			required: true
		}
	},
	data() {
		return {
			
		}
	},
	methods: {
		getStepClass( step ) {
			const index = step.index,
				active = step.active,
				steps_mode = this.stepsMode,
				current_step_index = this.currentStepIndex,
				inactiveClass = ( steps_mode != 'relaxed' && ! active ) ? 'inactive' : 'active',
				currentClass = index == current_step_index ? 'current' : ''
			return `step-item  ${ inactiveClass } ${ currentClass }`
		},
	},
	computed: {

	}
}
</script>